/**
 * Waits for an element matching the selector to appear in the DOM.
 * Resolves immediately if the element already exists.
 */
function waitForElement(
    selector: string,
    options: { timeout?: number } = {}
): Promise<Element> {

    const { timeout = 8000 } = options;

	return new Promise((resolve, reject) => {
		
		const existing = document.querySelector(selector);
		
		if (existing) {
			
			return resolve(existing);
			
        }

		const observer = new MutationObserver(() => {
			
			const el = document.querySelector(selector);
			
			if (el) {
				
                observer.disconnect();
				resolve(el);
				
			}
			
        });

        observer.observe(document.documentElement, { childList: true, subtree: true });

		setTimeout(() => {
			
            observer.disconnect();
			reject(new Error(`Timeout waiting for element: ${selector}`));
			
		}, timeout);
		
	});
	
}

export default waitForElement;